<script setup lang="ts">
import { Action } from "@/stores/permission";
import { mdiCheck, mdiClose } from "@mdi/js";
import { Badge, Icon } from "@soft-db/ui";

defineProps<{
	action: Action;
	hasAccess: boolean;
	center?: boolean;
}>();

const { t } = useI18n();

function actionLabel(action: Action): string {
	switch (action) {
		case "get":
			return t("common.view");
		case "update":
			return t("common.update");
		case "create":
			return t("common.create");
		case "delete":
			return t("common.delete");

		case "subscribe":
			return t("common.subscribe");
	}

	return "";
}
</script>

<template>
	<Badge
		:class="['w-full overflow-hidden text-nowrap', center ? 'justify-center' : 'justify-start']"
		:color="hasAccess ? 'success' : 'error'"
		variant="soft"
	>
		<Icon v-if="hasAccess" :d="mdiCheck" />
		<Icon v-else :d="mdiClose" />
		{{ actionLabel(action) }}
	</Badge>
</template>
